const ChartIcon = ({ active }) => {
  const color = active ? "#0149AD" : "#545454";
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8125 9.39239C10.249 13.0975 5.16504 14.1772 2.25089 11.2901C-0.60657 8.45918 0.278082 3.33052 4.03533 1.6875"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M10.0519 7.3125C11.2317 7.3125 11.8216 7.3125 12.2026 6.78436C12.2168 6.76463 12.2405 6.72921 12.2533 6.70851C12.5954 6.15444 12.4191 5.72875 12.0664 4.87737C11.7466 4.10533 11.2779 3.40385 10.687 2.81296C10.0961 2.22207 9.39465 1.75335 8.62262 1.43357C7.77124 1.08091 7.34555 0.904584 6.79148 1.24673C6.77077 1.25952 6.73536 1.28318 6.71562 1.29742C6.18748 1.67838 6.18748 2.26826 6.18748 3.44804V4.76717C6.18748 5.96705 6.18748 6.56699 6.56024 6.93975C6.93299 7.3125 7.53293 7.3125 8.73281 7.3125H10.0519Z"
        stroke={color}
      />
    </svg>
  );
};

export default ChartIcon;
